var map = {
	"./en-cd.json": 1230,
	"./en-gh.json": 1231,
	"./en-ke.json": 1232,
	"./en-mw.json": 1233,
	"./en-ng.json": 1234,
	"./en-ug.json": 1235,
	"./fr-cd.json": 1236,
	"./sw-ke.json": 1237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1229;